import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { PublicService } from 'src/app/services/public/public.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from "moment"

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.css']
})
export class ApplicationComponent implements OnInit {

  SchoolBranchList=[];
  AcademicSessionList=[];
  ClassList=[];
  BloodGroupList=[];
  NationalityList=[];
  ReligionList=[];
  MotherTongueList=[];
  SpecialCategoryList=[];
  CategoryList=[];
  DocumentList=[];
  DECLARATION1=false;

  constructor(private  publicService:PublicService, private spinnerService: Ng4LoadingSpinnerService, 
    public globalHelper: GlobalHelper,private activatedRoute: ActivatedRoute) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.StudentEnquiryModel.BranchID = params['BranchID'];
        this.StudentEnquiryModel.SchoolID = params['SchoolID'];
        this.StudentEnquiryModel.BranchName = params['BranchName'];
      });
     }

  StudentEnquiryModel =
  {
    BranchID:0,
    SchoolID:0,
    BranchName:'',
    SessionID:0,
    FirstName: "",
    MiddleName: '',
    LastName: '',
    Gender: '0',
    DOB: '',
    PlaceOfBirth: '',
    NationalityID:0,
    ReligionID:0,
    BloodGroupID:0,
    MotherTongueID:0,
    Mobile:'',
    EmailID:'',
    PrevClassID:0,
    PrevSchool:'',
    CategoryID:0,
    SpecialCategoryID:0,
    ClassID:0,
    FatherName:'',
    FatherOccupation:'',
    MotherName:'',
    MotherOccupation:'',
    HouseNo:'',
    StreetName:'',
    WayNo:'',
    Locality:'',
    POBox:'',
    PresentZipCode:'',
    FatherContactWork:'',
    FatherContactHome:'',
    PermanentAddress:'',
    DocumentID:0,
    ParentID: 0,
    StudentID:0,
    RegistrationNumber:'',
   };
  ngOnInit() {     
    this.GetBranchSession(); 
    this.GetSpecialCategory();
    this.GetCategory();
    this.GetClass();
    this.GetReligion();
    this.GetMotherTongue();
    this.GetNationality();
    this.GetBloodGroup();
   }

 
GetBranchSession() {
    var itembo = {
      'BranchID': this.StudentEnquiryModel.BranchID
    }
    this.publicService.GetLookupsList('AdmissionSession', JSON.stringify(itembo)).subscribe((data) => {
      this.AcademicSessionList = data.LookupItems;
    });
  };

  GetDocument() {
    var itembo = {
      'BranchID': this.StudentEnquiryModel.BranchID,
      'ItemID': this.StudentEnquiryModel.ClassID
    }
    this.publicService.GetLookupsList('DocumentName', JSON.stringify(itembo)).subscribe((data) => {
      data.LookupItems.splice(0, 1);
      this.DocumentList = data.LookupItems;
    });
  };

  GetClass() {  
    var ItemBO = {
      BranchID: this.StudentEnquiryModel.BranchID
    }
    this.publicService.GetLookupsList('Class', JSON.stringify(ItemBO)).subscribe((data) => {
      this.ClassList = data.LookupItems;
    });
  };

  GetBloodGroup() {
    this.publicService.GetLookupsList('BloodGroup', '').subscribe((data) => {
      this.BloodGroupList = data.LookupItems;
    });
  };



  GetNationality() {

    this.publicService.GetLookupsList('Nationality', '').subscribe((data) => {
      this.NationalityList = data.LookupItems;
    });
  };

  GetReligion() {

    this.publicService.GetLookupsList('Religion', '').subscribe((data) => {
      this.ReligionList = data.LookupItems;


    });
  }
  GetMotherTongue() {

    this.publicService.GetLookupsList('MotherTongue', '').subscribe((data) => {
      this.MotherTongueList = data.LookupItems;


    });
  }

  GetSpecialCategory() {
    var ItemBO = {
      BranchID: this.StudentEnquiryModel.BranchID
    }
    this.publicService.GetLookupsList('SpecialCategory', JSON.stringify(ItemBO)).subscribe((data) => {
      this.SpecialCategoryList = data.LookupItems;


    });

  };
  GetCategory() {
    var ItemBO = {
      BranchID: this.StudentEnquiryModel.BranchID
    }
    this.publicService.GetLookupsList('Category', JSON.stringify(ItemBO)).subscribe((data) => {
      this.CategoryList = data.LookupItems;


    });

  };


  // Document
 GetDocumentName(DocumentID) {
    for (var i = 0; i < this.DocumentList.length; i++) {
        if (this.DocumentList[i].ItemId == DocumentID) {
            return this.DocumentList[i].ItemName;
        }
    }
}

DocsList = [];
selectFileforUpload = function (file) {
    this.SelectedFileForUpload = file[0];
};

Docmsg:any;
MesgAlert:any;
SelectedFileForUpload:any;
FileAdd() {
    this.Docmsg = "";
    this.MesgAlert = "";
    if (this.SelectedFileForUpload == null) {
        this.Docmsg = 'Please Browser file';
        return;
    }
    for (var i = 0; i < this.DocsList.length; i++) {
        if (this.DocsList[i].DocumentID == this.StudentEnquiryModel.DocumentID) {
            this.Docmsg = 'Document  already exist';
            return;
        }
    }
    var item = {
        StudentAdmissionDocumentID: 0,
        DocumentID: this.StudentEnquiryModel.DocumentID,
        DocumentName: this.GetDocumentName(this.StudentEnquiryModel.DocumentID),
        FileUpload: this.SelectedFileForUpload,
        FileName: this.SelectedFileForUpload.name
    };
    this.DocsList.push(item);

}; 

removeRowDoc(index) {
  this.Docmsg = '';
  this.DocsList.splice(index, 1);

};

ValidateApplication() {
  return this.StudentEnquiryModel.Gender == '0' || this.StudentEnquiryModel.ClassID == 0;
};
SubmittedBasicDetails=false;
MesgDECLARATION='';

SaveApplication(valid) {

  this.SubmittedBasicDetails = true;

  if (valid && !this.ValidateApplication()) {
      if (this.DocsList.length == 0) {
          this.MesgAlert = 'Please Upload  Mandatory Document';
          return;
      }

      for (var i = 0; i < this.DocumentList.length; i++) {
          var flag = false;
          if (this.DocumentList[i].IsCompulsary) {
              for (var j = 0; j < this.DocsList.length; j++) {
                  if (this.DocumentList[i].ItemId == this.DocsList[j].DocumentID) {
                      flag = true;
                  }
              }
          }
          if (this.DocumentList[i].IsCompulsary && !flag) {
              this.MesgAlert = "Please Upload  Mandatory Document"
              return;
          }
      }


      if (this.DECLARATION1 == false) {
          this.MesgDECLARATION = 'Please Accept Declaration ';
          return;
      }

      this.spinnerService.show();
      this.StudentEnquiryModel.DOB = this.StudentEnquiryModel.DOB != null && this.StudentEnquiryModel.DOB != '' ? moment(this.StudentEnquiryModel.DOB).format('DD-MMM-YYYY') : '';
      this.publicService.SaveApplication(JSON.stringify(this.StudentEnquiryModel),this.DocsList).subscribe((response) => {
          // this.Mesg = "";
          this.spinnerService.hide();
          if (response.webResponse.Status) {
              this.globalHelper.CheckActionStatus(response);
              this.SubmittedBasicDetails = false;
              this.StudentEnquiryModel.StudentID = response.StudentID;
              this.StudentEnquiryModel.RegistrationNumber = response.RegistrationNumber;
             
          }
          if (response.webResponse.Status) {
              window.location = response.url;
          }
          else
              alert(response.webResponse.Message);
      });
  }
}

}
